/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindReqVo
 */
export interface OAuthBindReqVo {
    /**
     * 绑定凭证
     * OAuth绑定凭证
     * @type {string}
     * @memberof OAuthBindReqVo
     */
    oauthBindToken: string;
    /**
     * 已注册会员手机号
     * 已注册会员手机号
     * @type {string}
     * @memberof OAuthBindReqVo
     */
    mobileNumber: string;
    /**
     * 短信验证码
     * 短信验证码
     * @type {string}
     * @memberof OAuthBindReqVo
     */
    verificationCode: string;
}

/**
 * Check if a given object implements the OAuthBindReqVo interface.
 */
export function instanceOfOAuthBindReqVo(value: object): value is OAuthBindReqVo {
    if (!('oauthBindToken' in value) || value['oauthBindToken'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    if (!('verificationCode' in value) || value['verificationCode'] === undefined) return false;
    return true;
}

export function OAuthBindReqVoFromJSON(json: any): OAuthBindReqVo {
    return OAuthBindReqVoFromJSONTyped(json, false);
}

export function OAuthBindReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'oauthBindToken': json['oauthBindToken'],
        'mobileNumber': json['mobileNumber'],
        'verificationCode': json['verificationCode'],
    };
}

export function OAuthBindReqVoToJSON(json: any): OAuthBindReqVo {
    return OAuthBindReqVoToJSONTyped(json, false);
}

export function OAuthBindReqVoToJSONTyped(value?: OAuthBindReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oauthBindToken': value['oauthBindToken'],
        'mobileNumber': value['mobileNumber'],
        'verificationCode': value['verificationCode'],
    };
}

